"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = itineraryWithBaggageFactory;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _size2 = _interopRequireDefault(require("lodash/size"));
var _format = require("@tajawal/web-core-sdk-v2/lib/utils/format.utils");
var _searchRequest = require("../utils/search-request.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function itineraryWithBaggageFactory(itinerary, extraBaggageOption) {
  if (!(0, _isPlainObject2.default)(itinerary) || !(0, _isPlainObject2.default)(extraBaggageOption) || !extraBaggageOption.amount) {
    return itinerary;
  }
  var baggageOptionPrice = extraBaggageOption.amount;
  var hasExtraBaggage = !!baggageOptionPrice;
  var addBaggageOptionToLegSegments = function addBaggageOptionToLegSegments(segments) {
    return (0, _map2.default)(segments, function (segment) {
      return _objectSpread(_objectSpread({}, segment), {}, {
        extraBaggageOption: extraBaggageOption,
        hasExtraBaggage: hasExtraBaggage
      });
    });
  };
  var currency = itinerary.currency,
    itineraryPrice = itinerary.price,
    itineraryTotalPrice = itinerary.totalPrice,
    pax = itinerary.pax;
  var legsCount = (0, _size2.default)(itinerary.legs);
  var paxCount = (0, _searchRequest.getAdultChildCount)(pax);
  var totalBaggageAmount = baggageOptionPrice * legsCount * paxCount;
  var itineraryPriceWithBaggage = itineraryTotalPrice + totalBaggageAmount;
  var price = _objectSpread(_objectSpread({}, itineraryPrice), {}, {
    total: itineraryPriceWithBaggage,
    currency: currency,
    extraBaggage: totalBaggageAmount
  });
  var displayPrice = (0, _mapValues2.default)(price, function (v) {
    return (0, _format.formatPriceWithDecimals)({
      price: v,
      decimal: 0,
      currentCurrency: currency
    });
  });
  var legs = (0, _map2.default)(itinerary.legs, function (leg) {
    return _objectSpread(_objectSpread({}, leg), {}, {
      extraBaggageOption: extraBaggageOption,
      hasExtraBaggage: hasExtraBaggage,
      segments: addBaggageOptionToLegSegments(leg.segments),
      segmentsWithTechnicalStops: addBaggageOptionToLegSegments(leg.segmentsWithTechnicalStops)
    });
  });
  return _objectSpread(_objectSpread({}, itinerary), {}, {
    price: price,
    displayPrice: displayPrice,
    totalPrice: itineraryPriceWithBaggage,
    extraBaggage: (0, _map2.default)(legs, function (leg) {
      return {
        legId: leg.id,
        option: leg.extraBaggageOption
      };
    }),
    legs: legs
  });
}